import BaseModel from "../core/BaseModel";
export default class CategoryDangerModel extends BaseModel {
  constructor() {
    super(
      {
        name: "category_danger",
        tableName: "danger",
        label: "Danh Sách Mối Nguy Theo Danh Mục",
        display_key: "name",
        default_order: { key: "created_at", direction: "asc" },
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: { 
            name: 'id', 
            type: "Uuid", 
            label: 'ID', 
            primaryKey: true,
            display: false
        },
        category_id: {
            name: 'category_id',
            label: 'Danh mục mối nguy',
            type: "Selection",
            custom: "SelectionText",
            filter: {
                type: "SelectScroll",
                optionLabel: "name",
                optionKey: "id",
                match: "equals",
            },
        },
        name: {
            name: 'name',
            type: "TEXT",
            label: 'Mối nguy',
            sortable: false,
            // width: 20,
            filter: {type: 'input',match: 'contains'}
        },
        created_name : {
            name: 'created_name', 
            type: "TEXT", 
            label: 'Người tạo',
        },
        created_at : {
            name: 'created_at', 
            type: "Datetime", 
            label: 'Ngày tạo',
        },
        updated_name : {
          name: 'updated_name', 
          type: "TEXT", 
          label: 'Người cập nhật',
        },
        status: {
          name: "status",
          label: "Trạng thái",
          type: "Selection",
          class: "center",
          options: [
            { value: "APPROVED", label: "Đã duyệt" },
            { value: "WAITTING", label: "Chưa duyệt" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        active: {
          name: "active",
          label: "Hiển thị",
          type: "Selection",
          custom: "SelectionText",
          class: "center",
          options: [
            { value: true, label: "Có" },
            { value: false, label: "Không" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        }
      }
    );
  }
}
